var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaperplanefill({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -70.4590 96.6300 70.4590",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.1504 7.03125C57.1777 7.03125 59.2773 4.39453 60.8398 0.390625L85.6445-64.4043C86.4258-66.3574 86.8652-68.1152 86.8652-69.5801C86.8652-72.3145 85.1562-74.0234 82.4707-74.0234C81.0059-74.0234 79.248-73.5352 77.2949-72.8027L12.0605-47.7539C8.64258-46.4844 5.85938-44.3359 5.85938-41.2598C5.85938-37.4023 8.88672-36.1328 12.7441-35.0098L32.2266-29.0527C34.9609-28.2227 36.377-28.2227 38.2324-29.9316L80.5664-69.2383C81.1035-69.7266 81.7383-69.6289 82.1289-69.2871C82.5684-68.8965 82.6172-68.2129 82.1289-67.6758L43.0176-25.1465C41.4062-23.3887 41.2598-22.0703 42.1387-19.1895L47.8027-0.244141C48.9746 3.80859 50.2441 7.03125 54.1504 7.03125Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperplanefill);
export default __webpack_public_path__ + "static/media/paperplane.fill.29d1f6596ac3bcb12edb7e85c4fe6a34.svg";
export { ForwardRef as ReactComponent };